import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import DeleteIcon from '@mui/icons-material/Delete'

import axios from '../../dataClient/dataClient'
import { StyledDialog, FlexDialogContent, FlexEndContainer } from '../styles/Containers'
import { ErrorMessage, SuccessMessage } from '../common/UserMessage'
import Button, { SecondaryButton, SecondaryIconButton } from '../common/Button'
import BodyText, { BoldSpan, BoldFormTitle } from '../styles/Text'

function DeleteLetterButton({ id, secondaryId, onSuccess = () => {} }) {
  const [isVisible, setIsVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)

  const isMounted = useRef(true)

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  function handleOpen() {
    setIsSuccess(false)
    setError(false)
    setIsVisible(true)
  }

  function handleClose() {
    setIsVisible(false)
    setError(false)
    setIsSuccess(false)
    setIsLoading(false)
    if (isSuccess) onSuccess(id)
  }

  function handleConfirm() {
    setIsLoading(true)
    setError(false)

    axios
      .delete(`/bill/${id}`)
      .then(() => {
        if (isMounted.current) {
          setIsSuccess(true)
        }
      })
      .catch(e => {
        if (isMounted.current) {
          setIsLoading(false)
          setError(true)
          console.error('failed to delete fee draft', id, e)
        }
      })
  }

  return (
    <>
      <SecondaryIconButton aria-label={`Delete Draft ${secondaryId}`} onClick={handleOpen}>
        <DeleteIcon fontSize="small" />
      </SecondaryIconButton>
      <StyledDialog fullWidth open={isVisible} onClose={handleClose} keepMounted={false}>
        <FlexDialogContent>
          <BoldFormTitle>Delete Fee Draft: {secondaryId}</BoldFormTitle>
          {isSuccess ? (
            <>
              <SuccessMessage>Draft successfully deleted</SuccessMessage>
              <FlexEndContainer>
                <SecondaryButton onClick={handleClose}>Close</SecondaryButton>
              </FlexEndContainer>
            </>
          ) : (
            <>
              <BodyText>
                Are you sure you want to delete the draft <BoldSpan>{secondaryId}</BoldSpan>?
              </BodyText>
              {error && <ErrorMessage>There was an error deleting the draft. Please try again.</ErrorMessage>}
              <FlexEndContainer>
                <SecondaryButton onClick={handleClose} disabled={isLoading}>
                  Cancel
                </SecondaryButton>
                <Button onClick={handleConfirm} loading={isLoading}>
                  Confirm
                </Button>
              </FlexEndContainer>
            </>
          )}
        </FlexDialogContent>
      </StyledDialog>
    </>
  )
}

DeleteLetterButton.propTypes = {
  id: PropTypes.string.isRequired,
  secondaryId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func
}

export default DeleteLetterButton
